import { z } from "zod";
import { User } from "../users";

export const NpmProxyToken = z.object({
  access: z.string(),
  expiresAt: z.number(),
});

export type NpmProxyToken = z.infer<typeof NpmProxyToken>;

export const SessionData = z.object({
  returnToUrl: z.string().optional(),
  npmProxyToken: NpmProxyToken.optional(),
});

export type SessionData = z.infer<typeof SessionData>;

export const Session = z.object({
  id: z.string(),
  expiresAt: z.coerce.date(),
  userId: z.string().nullable(),
  anonymousId: z.string().nullable(),
  data: SessionData,
});

export type Session = z.infer<typeof Session>;

export const AuthTokens = z.object({
  access: z.string(),
  refresh: z.string(),
});

export type AuthTokens = z.infer<typeof AuthTokens>;

export const UserSession = z.object({
  session: Session,
  user: User.nullable(),
});

export type UserSession = z.infer<typeof UserSession>;
